/* Guardadas (23 oct 2026): el corazón guarda cartas en ESTE navegador (localStorage «moons-guardadas», máximo 60) y
   el panel junto al carrito las lista con sus datos ACTUALES (/products/<handle>.js): escaneo, nombre, set · número ·
   estado, precio público o «Vendida». No guarda precios ni estados; no aparta nada. Un solo manejador para toda la
   página (delegación), así los corazones de las tarjetas que agrega «cargar más» funcionan sin volver a enganchar;
   un MutationObserver les quita el hidden y les pone su estado. window.MoonsGuardadas: lee(), tiene(h), alterna(h, n). */
(function () {
  if (window.MoonsGuardadas) return;
  var CLAVE = 'moons-guardadas';
  var MAX = 60;

  function lee() {
    try {
      var l = JSON.parse(localStorage.getItem(CLAVE) || '[]');
      return Array.isArray(l) ? l.filter(function (x) { return x && x.h; }) : [];
    } catch (e) { return []; }
  }
  function guarda(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, MAX))); } catch (e) {}
  }
  function tiene(h) {
    return lee().some(function (x) { return x.h === h; });
  }
  function alterna(h, n) {
    var lista = lee();
    var habia = lista.some(function (x) { return x.h === h; });
    lista = lista.filter(function (x) { return x.h !== h; });
    if (!habia) lista.unshift({ h: h, n: n || '', t: Date.now() });
    guarda(lista);
    pinta();
    return !habia;
  }
  function quita(h) {
    guarda(lee().filter(function (x) { return x.h !== h; }));
    pinta();
  }

  /* Botones: estado, texto y conteos */
  function pintaBoton(b) {
    var h = b.getAttribute('data-handle');
    var esta = tiene(h);
    b.hidden = false;
    b.classList.toggle('is-guardada', esta);
    b.setAttribute('aria-pressed', esta ? 'true' : 'false');
    var texto = b.querySelector('[data-guardar-texto]');
    if (texto) texto.textContent = b.getAttribute(esta ? 'data-t-guardada' : 'data-t-guardar') || '';
  }
  function pinta() {
    var n = lee().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-guardar]'), pintaBoton);
    Array.prototype.forEach.call(document.querySelectorAll('[data-guardadas-abrir]'), function (b) { b.hidden = false; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-guardadas-conteo]'), function (c) {
      c.textContent = n ? String(n) : '';
      c.hidden = !n;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-guardadas-conteo-panel]'), function (c) {
      c.textContent = n ? '(' + n + ')' : '';
    });
    var vaciar = document.querySelector('[data-guardadas-vaciar]');
    if (vaciar) vaciar.hidden = !n;
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-guardar]');
    if (b) {
      ev.preventDefault();
      alterna(b.getAttribute('data-handle'), b.getAttribute('data-nombre'));
      return;
    }
    var q = ev.target.closest && ev.target.closest('[data-guardadas-quitar]');
    if (q) {
      ev.preventDefault();
      quita(q.getAttribute('data-handle'));
      llena();
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-guardadas-abrir]')) { ev.preventDefault(); abre(); return; }
    if (ev.target.closest && ev.target.closest('[data-guardadas-cerrar]')) { ev.preventDefault(); cierra(); return; }
    if (ev.target.closest && ev.target.closest('[data-guardadas-vaciar]')) {
      ev.preventDefault();
      guarda([]);
      pinta();
      llena();
    }
  });

  /* Panel */
  var panel = document.querySelector('[data-guardadas-panel]');
  var quienAbrio = null;
  var precios = { factor: 1, fijo: 0 };
  try {
    var pj = document.querySelector('[data-moons-precios]');
    if (pj) precios = JSON.parse(pj.textContent);
  } catch (e) {}
  var formato;
  try { formato = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }); } catch (e) { formato = null; }
  function dinero(n) { return formato ? formato.format(n) : '$' + n.toFixed(2); }
  function publico(baseCentavos) { return Math.round(baseCentavos * precios.factor + precios.fijo * 100) / 100; }
  function imagen(url, ancho) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + ancho;
  }
  function pieza(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .catch(function () { return null; });
  }

  var cache = {};
  function llena() {
    if (!panel) return;
    var lista = panel.querySelector('[data-guardadas-lista]');
    var vacio = panel.querySelector('[data-guardadas-vacio]');
    var plantilla = panel.querySelector('[data-guardadas-plantilla]');
    if (!lista || !plantilla) return;
    var items = lee();
    lista.innerHTML = '';
    if (vacio) vacio.hidden = !!items.length;
    if (!items.length) return;
    var tVendida = lista.getAttribute('data-t-vendida') || 'Vendida';
    var tQuitar = lista.getAttribute('data-t-quitar') || 'Quitar';
    /* Primero lo que sabemos (nombre), luego los datos vivos */
    items.forEach(function (it) {
      var nodo = plantilla.content.firstElementChild.cloneNode(true);
      nodo.setAttribute('data-handle', it.h);
      nodo.querySelector('.guardadas__enlace').href = '/products/' + it.h;
      nodo.querySelector('.guardadas__nombre').textContent = it.n || it.h;
      var q = nodo.querySelector('[data-guardadas-quitar]');
      q.setAttribute('data-handle', it.h);
      q.textContent = tQuitar;
      q.setAttribute('aria-label', tQuitar + ' ' + (it.n || it.h));
      lista.appendChild(nodo);
      var listo = cache[it.h] ? Promise.resolve(cache[it.h]) : pieza(it.h).then(function (p) { if (p) cache[it.h] = p; return p; });
      listo.then(function (p) {
        var img = nodo.querySelector('.guardadas__img');
        var datos = nodo.querySelector('.guardadas__datos');
        var precio = nodo.querySelector('.guardadas__precio');
        if (!p) {
          /* La ficha ya no existe: se queda el nombre y se marca como vendida */
          if (img && img.parentNode) img.parentNode.removeChild(img);
          precio.textContent = tVendida;
          nodo.classList.add('is-vendida');
          return;
        }
        var partes = String(p.title || '').split(' · ');
        nodo.querySelector('.guardadas__nombre').textContent = partes[0] || p.title;
        datos.textContent = partes.slice(1).join(' · ');
        if (p.featured_image && img) { img.src = imagen(p.featured_image, 96); img.srcset = imagen(p.featured_image, 96) + ' 96w, ' + imagen(p.featured_image, 192) + ' 192w'; img.sizes = '3rem'; }
        else if (img && img.parentNode) img.parentNode.removeChild(img);
        var v = p.variants && p.variants[0];
        if (!p.available) { precio.textContent = tVendida; nodo.classList.add('is-vendida'); }
        else if (v) {
          /* publico() ya devuelve pesos; accesorios y membresías van tal cual (sin regla de cartas) */
          var pesos = p.type === 'Accesorio' || p.type === 'Sellado' || p.type === 'Membresía' ? v.price / 100 : publico(v.price);
          precio.textContent = dinero(pesos);
        }
      });
    });
  }

  function abre() {
    if (!panel || typeof panel.showModal !== 'function') return;
    quienAbrio = document.activeElement;
    llena();
    panel.showModal();
    document.documentElement.classList.add('is-guardadas-abierta');
    Array.prototype.forEach.call(document.querySelectorAll('[data-guardadas-abrir]'), function (b) { b.setAttribute('aria-expanded', 'true'); });
    var cerrar = panel.querySelector('[data-guardadas-cerrar]');
    if (cerrar) cerrar.focus();
  }
  function cierra() {
    if (!panel || !panel.open) return;
    panel.close();
  }
  if (panel) {
    panel.addEventListener('close', function () {
      document.documentElement.classList.remove('is-guardadas-abierta');
      Array.prototype.forEach.call(document.querySelectorAll('[data-guardadas-abrir]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (quienAbrio && quienAbrio.focus && document.contains(quienAbrio) && !quienAbrio.hidden) quienAbrio.focus();
    });
    /* Clic fuera (en el fondo): el dialog recibe el clic con target = él mismo */
    panel.addEventListener('click', function (ev) {
      if (ev.target === panel) cierra();
    });
  }

  /* Tarjetas que llegan después (cargar más, Parecidas, Para ti, Sorpréndeme) */
  var pendiente = null;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () {
        pendiente = null;
        Array.prototype.forEach.call(document.querySelectorAll('[data-guardar][hidden]'), pintaBoton);
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Otra pestaña cambió la lista */
  window.addEventListener('storage', function (ev) {
    if (ev.key === CLAVE) { pinta(); if (panel && panel.open) llena(); }
  });

  window.MoonsGuardadas = { lee: lee, tiene: tiene, alterna: alterna, quita: quita, abre: abre };
  pinta();
})();
